import { wechatSign } from "@/apis/sdkhb";
import { WX_APP_ID } from "@/config";

export default async () => {
  const data = {
    url: location.hostname + location.pathname,
    app_id: WX_APP_ID
  }
  console.log(data)
  const r = await wechatSign(data);
  console.log(r)
  if (r.return_code !== "SUCCESS") {
    console.log("get_wechat_sign error");
    return;
  }
  const { timestamp, signature, noncestr } = r.return_msg;

  window.wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: WX_APP_ID, // 必填，公众号的唯一标识
    timestamp: timestamp, // 必填，生成签名的时间戳
    nonceStr: noncestr, // 必填，生成签名的随机串
    signature: signature, // 必填，签名
    jsApiList: ["closeWindow"], // 必填，需要使用的JS接口列表
  });

  window.wx.ready(function() {
    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
  });

  // wx.closeWindow();
};
